import { render, staticRenderFns } from "./GoalTipConfirm.vue?vue&type=template&id=59ffc9aa&"
import script from "./GoalTipConfirm.vue?vue&type=script&lang=ts&"
export * from "./GoalTipConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports